import type { ComponentPropsWithRef, ReactNode } from 'react';

import { Drawer as BaseDrawer } from '@base-ui/react';
import { useTranslation } from 'react-i18next';

import { clsx } from '~/styles/utils';

import { Button } from '../Button/Button';
import { Title } from '../Title/Title';
import { descriptionStyle, headerStyle, headerTextStyle } from './Drawer.css';

type Props = Omit<ComponentPropsWithRef<'div'>, 'title'> & {
  description?: ReactNode;
  hideCloseButton?: boolean;
  title?: ReactNode;
};

export const DrawerHeader = ({ children, description, hideCloseButton = false, title, ...delegated }: Props) => {
  const { t } = useTranslation(['common']);

  return (
    <div {...delegated} className={clsx(headerStyle, delegated.className)}>
      {(title || description) && (
        <div className={headerTextStyle}>
          {title && <BaseDrawer.Title render={<Title as="h2" />}>{title}</BaseDrawer.Title>}

          {description && <BaseDrawer.Description className={descriptionStyle}>{description}</BaseDrawer.Description>}
        </div>
      )}

      {children}

      {!hideCloseButton && <BaseDrawer.Close render={<Button aria-label={t('common:actions.close')} icon="CloseSmall" />} />}
    </div>
  );
};
